<template>
  <div class="jm-page">
    <!-- วงกลมตกแต่งพื้นหลัง -->
    <span class="jm-blob jm-blob--tl"></span>
    <span class="jm-blob jm-blob--tc"></span>
    <span class="jm-blob jm-blob--br"></span>

    <div class="jm-wrap">
      <!-- ===== ซ้าย: ข้อความ ===== -->
      <div class="jm-left reveal">
        <div class="jm-badge">
          <v-icon size="14" color="#215295">mdi-video-outline</v-icon>
          {{ lg_joinmeetbtid.jm_page_label }}
        </div>

        <h1 class="jm-heading">
          {{ headingLines[0] }}<br />
          <span class="jm-heading-blue">{{ headingLines[1] }}</span>
        </h1>

        <p class="jm-sub">{{ lg_joinmeetbtid.jm_subheading }}</p>

        <ul class="jm-benefits">
          <li v-for="b in benefits" :key="b.key">
            <span class="jm-benefit-icon">
              <v-icon size="18" color="#215295">{{ b.icon }}</v-icon>
            </span>
            {{ lg_joinmeetbtid[b.key] }}
          </li>
        </ul>

        <!-- ภาพจุดวงกลมเส้นประ -->
        <svg class="jm-dots" width="210" height="100" viewBox="0 0 210 100" fill="none" aria-hidden="true">
          <circle cx="40" cy="52" r="32" stroke="#c7d2e3" stroke-width="1.5" stroke-dasharray="4 4" />
          <circle cx="110" cy="52" r="48" stroke="#dbe3ee" stroke-width="1.5" stroke-dasharray="4 4" />
          <circle cx="180" cy="52" r="24" stroke="#c7d2e3" stroke-width="1.5" stroke-dasharray="4 4" />
          <circle cx="40" cy="52" r="4" fill="#c7d2e3" />
          <circle cx="110" cy="52" r="4" fill="#c7d2e3" />
          <circle cx="180" cy="52" r="4" fill="#c7d2e3" />
          <line x1="66" y1="52" x2="72" y2="52" stroke="#c7d2e3" stroke-width="1.5" />
          <line x1="150" y1="52" x2="158" y2="52" stroke="#c7d2e3" stroke-width="1.5" />
        </svg>
      </div>

      <!-- ===== ขวา: การ์ดเข้าห้อง ===== -->
      <div class="jm-right reveal">
        <div class="jm-card">
          <div class="jm-card-head">
            <span class="jm-card-icon">
              <v-icon size="22" color="#215295">mdi-video-outline</v-icon>
            </span>
            <div>
              <h2 class="jm-card-title">{{ lg_joinmeetbtid.jm_card_title }}</h2>
              <p class="jm-card-desc">{{ lg_joinmeetbtid.jm_card_desc }}</p>
            </div>
          </div>

          <form novalidate @submit.prevent="onSubmit">
            <label for="jm-code" class="jm-label">{{ lg_joinmeetbtid.jm_code_label }}</label>
            <div class="jm-input" :class="{ 'has-error': errorText }">
              <v-icon size="18" color="#9ca3af">mdi-video-outline</v-icon>
              <input
                id="jm-code"
                v-model="form.meetId"
                type="text"
                inputmode="numeric"
                autocomplete="off"
                :placeholder="lg_joinmeetbtid.jm_code_placeholder"
                @keypress="isNumber($event)"
                @input="errorText = ''"
              />
              <button type="button" class="jm-paste" @click="onPaste">
                <v-icon size="14" color="#215295">mdi-clipboard-outline</v-icon>
                {{ lg_joinmeetbtid.jm_paste }}
              </button>
            </div>
            <small v-if="errorText" class="jm-error">{{ errorText }}</small>
            <small v-else class="jm-helper">{{ lg_joinmeetbtid.jm_code_helper }}</small>

            <button type="submit" class="jm-submit" :disabled="checking">
              <template v-if="checking">{{ lg_joinmeetbtid.jm_checking }}</template>
              <template v-else>
                {{ lg_joinmeetbtid.jm_continue }}
                <v-icon size="18" color="white">mdi-arrow-right</v-icon>
              </template>
            </button>
          </form>

          <div class="jm-divider"><span>{{ lg_joinmeetbtid.jm_or }}</span></div>

          <p class="jm-signin">
            {{ lg_joinmeetbtid.jm_already_account }}
            <a @click="onClickMenu('/login-account')">{{ lg_joinmeetbtid.jm_signin_link }}</a>
          </p>
        </div>

        <div class="jm-trust">
          <v-icon size="18" color="#215295">mdi-shield-outline</v-icon>
          <div>
            <p class="jm-trust-title">{{ lg_joinmeetbtid.jm_trust_title }}</p>
            <p class="jm-trust-desc">{{ lg_joinmeetbtid.jm_trust_desc }}</p>
          </div>
        </div>
      </div>
    </div>

    <LoadingDialog></LoadingDialog>
  </div>
</template>

<script>
import api from "@/services/api";
import { lg_joinmeetbtid } from "./language/lg_header_joinmeetbyid.js";
import { feature } from "../services/constants.js";
import LoadingDialog from "@/components/cards/LoadingDialog";

export default {
  components: { LoadingDialog },
  data: () => ({
    lg_joinmeetbtid: {},
    form: {
      meetId: undefined,
    },
    emailRules: [],
    isRequired: true,
    errorText: "",
    checking: false,
    benefits: [
      { key: "jm_benefit1", icon: "mdi-shield-outline" },
      { key: "jm_benefit2", icon: "mdi-check-circle-outline" },
      { key: "jm_benefit3", icon: "mdi-lock-outline" },
    ],
    timers: [],
  }),
  computed: {
    headingLines() {
      return String(this.lg_joinmeetbtid.jm_heading || "").split("\n");
    },
  },
  methods: {
    // พิมพ์ได้เฉพาะตัวเลข (เหมือนเดิม)
    isNumber(evt) {
      evt = evt ? evt : window.event;
      const charCode = evt.which ? evt.which : evt.keyCode;
      if (charCode > 31 && (charCode < 48 || charCode > 57)) {
        evt.preventDefault();
      } else {
        return true;
      }
    },
    // ปุ่ม Paste: ดึงเฉพาะตัวเลขจากข้อความ/ลิงก์ที่คัดลอกมา
    async onPaste() {
      try {
        const text = await navigator.clipboard.readText();
        const matches = String(text).match(/\d+/g);
        if (matches) {
          this.form.meetId = matches[matches.length - 1];
          this.errorText = "";
        }
      } catch (e) {
        document.getElementById("jm-code").focus();
      }
    },
    // ตรวจค่าว่างตาม emailRules เดิม
    validate() {
      for (const rule of this.emailRules) {
        const res = rule(this.form.meetId);
        if (res !== true) {
          this.errorText = res;
          return false;
        }
      }
      this.errorText = "";
      return true;
    },
    async onSubmit() {
      if (this.validate()) {
        this.checking = true;
        try {
          const { meetId } = this.form;
          const res = await api.getByMeetNameOnlydyte(meetId.trim());
          const {
            data: { meet_appid, meet_sta },
          } = res;
          if (meet_sta !== "Y") {
            throw new Error("The meeting was finished");
          }
          // const url = `/meet/${meetId.trim()}/meeting`;
          const url = `/meet/${meetId.trim()}`;

          // this.resultJson = await api.getAllAppId();
          // this.appId = this.resultJson.data[0].app_id_name;

          this.$router.push(url);
        } catch (error) {
          if (error.response?.status === 404) {
            this.$swal.fire("ผิดพลาด", "Meeting ID ไม่ถูกต้อง", "error");
          } else {
            this.$swal.fire("ผิดพลาด", error?.message, "error");
          }
        } finally {
          this.checking = false;
        }
      }
    },
    onClickMenu(link) {
      this.$router.push(link).catch(() => {});
    },
  },
  watch: {
    isRequired(val) {
      if (val) {
        this.emailRules = [(v) => !!v || `${this.lg_joinmeetbtid.put_required}`];
      } else {
        this.emailRules = [];
      }
    },
  },
  created() {
    this.$store.state.page_reload = false;
    this.$store.state.meetSta = false;
    this.$store.state.loadFooter = false;

    localStorage.getItem(feature.LANGUAGE) === "th"
      ? (this.lg_joinmeetbtid = lg_joinmeetbtid.lg_joinmeetbtid_th)
      : (this.lg_joinmeetbtid = lg_joinmeetbtid.lg_joinmeetbtid_en);
  },
  mounted() {
    this.emailRules = this.isRequired
      ? [(v) => !!v || `${this.lg_joinmeetbtid.put_required}`]
      : [];

    // animation สไลด์ขึ้นตอนโหลด (เหมือนหน้าอื่น)
    this.$el.querySelectorAll(".reveal").forEach((el, i) => {
      this.timers.push(
        setTimeout(() => el.classList.add("reveal--visible"), 200 + i * 150)
      );
    });
  },
  beforeDestroy() {
    this.timers.forEach(clearTimeout);
  },
  beforeUnmount() {
    this.timers.forEach(clearTimeout);
  },
};
</script>

<style scoped>
.jm-page {
  position: relative;
  overflow: hidden;
  min-height: calc(100vh - 70px);
  background: #f8fafc;
  display: flex;
  align-items: center;
  padding: 80px 0;
  color: #0f172a;
}

/* วงกลมพื้นหลัง */
.jm-blob {
  position: absolute;
  border-radius: 50%;
  background: #eef2f7;
  pointer-events: none;
}
.jm-blob--tl { width: 640px; height: 640px; left: -170px; top: -250px; }
.jm-blob--tc { width: 360px; height: 360px; left: 46%; top: -200px; }
.jm-blob--br { width: 720px; height: 720px; right: -360px; bottom: -420px; }

.jm-wrap {
  position: relative;
  z-index: 1;
  width: 100%;
  max-width: 1140px;
  margin: 0 auto;
  padding: 0 24px;
  display: grid;
  grid-template-columns: minmax(0, 1fr);  /* was 1fr */
  gap: 48px;
  align-items: center;
  box-sizing: border-box;
}
@media (min-width: 960px) {
  .jm-wrap { grid-template-columns: 1fr 500px; gap: 80px; }
}

/* ===== ซ้าย ===== */
.jm-badge {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 6px 12px;
  border-radius: 9999px;
  background: rgba(33, 82, 149, 0.1);
  color: #215295;
  font-size: 13px;
  font-weight: 600;
  letter-spacing: 0.5px;
  text-transform: uppercase;
  margin-bottom: 32px;
}
.jm-heading {
  font-size: 48px;
  line-height: 1.15;
  font-weight: 700;
  letter-spacing: -0.5px;
  margin: 0 0 40px;
}
.jm-heading-blue {
  color: #215295;
}
.jm-sub {
  font-size: 17px;
  line-height: 1.65;
  color: #475569;
  max-width: 420px;
  margin: 0 0 32px;
}
.jm-benefits {
  list-style: none;
  padding: 0;
  margin: 0 0 48px;
  display: flex;
  flex-direction: column;
  gap: 14px;
}
.jm-benefits li {
  display: flex;
  align-items: center;
  gap: 12px;
  font-size: 15px;
  color: #1e293b;
}
.jm-benefit-icon {
  width: 36px;
  height: 36px;
  border-radius: 8px;
  background: #e8eef6;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}
.jm-dots {
  display: block;
}

/* ===== ขวา ===== */
.jm-card {
  background: #ffffff;
  border: 1px solid #e5e7eb;
  border-radius: 16px;
  padding: 36px;
  box-shadow: 0 10px 30px rgba(15, 23, 42, 0.06);
}

.jm-card-head {
  display: flex;
  gap: 14px;
  margin-bottom: 28px;
}
.jm-card-icon {
  width: 44px;
  height: 44px;
  border-radius: 10px;
  background: #e8eef6;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}
.jm-card-title {
  font-size: 20px;
  font-weight: 600;
  margin: 0 0 6px;
}
.jm-card-desc {
  font-size: 13px;
  line-height: 1.55;
  color: #64748b;
  margin: 0;
}
.jm-label {
  display: block;
  font-size: 13px;
  font-weight: 600;
  margin-bottom: 8px;
}
.jm-input {
  display: flex;
  align-items: center;
  gap: 10px;
  border: 1px solid #d1d5db;
  border-radius: 8px;
  padding: 6px 6px 6px 12px;
  background: #ffffff;
  transition: border-color 0.15s ease;
}
.jm-input:focus-within {
  border-color: #215295;
}
.jm-input.has-error {
  border-color: #ef4444;
}
.jm-input input {
  flex: 1;
  min-width: 0;
  border: none;
  outline: none !important;
  font: inherit;
  font-size: 15px;
  letter-spacing: 1px;
  color: #0f172a;
  background: transparent;
  padding: 6px 0;
}
.jm-paste {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  padding: 5px 10px;
  border: none;
  border-radius: 6px;
  background: #eef2f7;
  color: #215295;
  font: inherit;
  font-size: 12px;
  font-weight: 600;
  cursor: pointer;
}
.jm-paste:hover {
  background: #e2e8f0;
}
.jm-helper,
.jm-error {
  display: block;
  font-size: 11px;
  margin: 6px 0 8px;
}
.jm-helper { color: #94a3b8; }
.jm-error { color: #ef4444; }
.jm-submit {
  width: 100%;
  height: 48px;
  border: none;
  border-radius: 8px;
  background: #215295;
  color: #ffffff;
  font: inherit;
  font-size: 15px;
  font-weight: 600;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  transition: background-color 0.15s ease;
}
.jm-submit:hover { background: #1b4580; }
.jm-submit:disabled { opacity: 0.7; cursor: default; }

.jm-divider {
  display: flex;
  align-items: center;
  gap: 12px;
  margin: 24px 0 16px;
  color: #94a3b8;
  font-size: 12px;
}
.jm-divider::before,
.jm-divider::after {
  content: "";
  flex: 1;
  height: 1px;
  background: #e5e7eb;
}
.jm-signin {
  text-align: center;
  font-size: 13px;
  color: #475569;
  margin: 0;
}
.jm-signin a {
  color: #215295 !important;
  font-weight: 600;
  cursor: pointer;
}
.jm-signin a:hover {
  text-decoration: underline;
}

.jm-trust {
  display: flex;
  gap: 12px;
  margin-top: 16px;
  padding: 14px 18px;
  border: 1px solid #e5e7eb;
  border-radius: 10px;
  background: rgba(255, 255, 255, 0.7);
}
.jm-trust-title {
  font-size: 13px;
  font-weight: 600;
  margin: 0 0 4px;
}
.jm-trust-desc {
  font-size: 12px;
  line-height: 1.5;
  color: #64748b;
  margin: 0;
}

/* Animation */
.reveal {
  opacity: 0;
  transform: translateY(40px);
  transition: opacity 0.8s ease, transform 0.8s ease;
}
.reveal--visible {
  opacity: 1;
  transform: translateY(0);
}
@media (max-width: 599px) {
  .jm-card { padding: 24px; }
  .jm-heading { font-size: 36px; }
}
@media (max-width: 959px) {
  .jm-left { display: none; }
  .jm-page {
    padding: 24px 0;
    align-items: start;      /* vertical center */
    justify-content: center;  /* horizontal center */
  }
  .jm-wrap {
    max-width: 540px;
    margin: 0 auto;
    justify-items: center;
  }
  .jm-right {
    width: 100%;
    max-width: 480px;
  }
}
@media (prefers-reduced-motion: reduce) {
  .reveal { opacity: 1; transform: none; transition: none; }
}
</style>